import UserError from 'usererror'

export class FileParsingError extends UserError {
  constructor(message) {
    super()
    this.message = message
  }
}
